import { Injectable } from '@angular/core';
import { BaseService } from '../base.service';
import { Acceso } from 'src/app/models/acceso.model';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Respuesta } from 'src/app/models/respuesta';
import { environment } from 'src/environments/environment';
import { CONFIG, HTTPOPTIONS } from 'src/app/common/constants';
import { map, tap, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AccesoService extends BaseService<Acceso> {

  private accesoUrl = `${environment.apiBaseUrl}/accesos`;

  constructor(public http: HttpClient) {
    super('AccesoService');
   }

   public findAll(): Observable<Acceso[]> {
    return this.http.get<Acceso[]>(`${this.accesoUrl}/?idapp=${CONFIG.IDAPP}`).pipe(
      map(res => res['accesos']),
      tap(_ => this.log('fetched accesos')),
      catchError(this.handleError('getAccesos'))
    );
   }

   public add(acceso: Acceso): Observable<Respuesta> {
    return this.http.post<Respuesta>(this.accesoUrl, acceso, HTTPOPTIONS).pipe(
      tap((res: Respuesta) => this.log(`agregar acceso`)),
      catchError(this.handleError('agregarAcceso'))
    );
  }

  public update(acceso: Acceso): Observable<Respuesta> {
    return this.http.put<Respuesta>(this.accesoUrl, acceso, HTTPOPTIONS).pipe(
      tap((res: Respuesta) => this.log(`Actualizar acceso`)),
      catchError(this.handleError('updateAcceso'))
    );
  }

  public delete(id: number): Observable<Respuesta> {
    const options = {
      headers: HTTPOPTIONS.headers,
      body: { id: id, idapp: CONFIG.IDAPP }
    };

    return this.http.delete<Respuesta>(`${this.accesoUrl}`, options).pipe(
      tap((res: Respuesta) => this.log(`deleted acceso | id=${res.id}`)),
      catchError(this.handleError('deleteAccesi'))
    );
  }

  public existingAcceso(nombre: string): Observable<Respuesta> {
    return this.http.post<Respuesta>(`${this.accesoUrl}/existing`, { c_nombre: nombre, c_idapp: CONFIG.IDAPP }, HTTPOPTIONS).pipe(
      tap(c_ => this.log(`exists acceso => ${nombre}`)),
      catchError(this.handleError('existingAcceso'))
    );
  }
}
